// import { sentryConfig as sentryConfigProd } from './sentry.config.prod';

export const environment = {
  production: true,
  disableLogging: true,
  isLocalAssets: false,
  isFixedOne3dFileName: false,
  encryptionPassword: 'UcK*hCW(7qcf{N3d',
  fmKey: 'eYzUkRzfih9WxfiqSp3gep',

  apiUrl: 'https://prod-apileapmotors-au.one3d.in/',
  assetsUrl: 'https://d282vjma0vnstb.cloudfront.net/',
  assetsUrlLocal: 'assets/',
  jeepUrl: 'https://www.leapmotor.com/au_en',
  carExchangeUrl:
    'https://jeepselectedforyou.in/used-car-valuation/?token=WS1ngjLGRSab13D8jTdU6dTrh',
  function_js: 'one3d_functions.min.js', //min.js will be extension for functions file confirmed with @sundaram 14/11/23
  hideTutorialModels: ['JL24'],
  appName: 'leapmotors-australia-web',
  appRelease: 'leapmotors-australia-prod',
  eeu: 'U2FsdGVkX18jrGBdGbjQy3Ox8Jr5gZEC1kH7jGwWj6uMFFbCcm69p+xgnlVHBQVD',
  eep: 'U2FsdGVkX1/3kh8Hh7wkZsy5aGdS01rW3C6nWfwuT4brgq46FiB8AU9Rf0zKO5vA',
  eect: '3d3286f7cd19074f04e514b0c6c237e757513fb32820698b790e1dec801d947a'
  // Sentry Settings (disabled)
  // ...sentryConfigProd,
};
